// extracted by mini-css-extract-plugin
export default {"productDescription":"Paa-z","featuredDescription":"Qaa-z","description":"Raa-z","more":"Saa-z","descriptionSku":"Taa-z"};